export default {
    hide: () => { }
};
